{
  "serviceForms": {
    "joinCorporateForm": {
      "fields": {
        "iataNumber": {
          "pattern": "IATA number can contain only 7 or 8 digits."
        }
      }
    }
  }
}
